{
  "it": {
    "partner": {
      "actions": {
        "add": "Aggiungi",
        "changeProfilePicture": "Cambia immagine del profilo",
        "new": "Partner",
        "profilePictureFormat": "Deve avere una dimensione minima di 300x300px",
        "save": "Salva",
        "sendinvitation": "Invia invito",
        "submit": "Salva",
        "undoChanges": "Annulla"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Una volta al giorno (verso mezzogiorno)",
          "hourly": "Ogni ora",
          "twice_daily": "Due volte al giorno (mattina/mezzogiorno)",
          "weekly": "Una volta a settimana (lunedì a mezzogiorno)"
        },
        "first_name": "Nome",
        "internal_note": "Nota interna",
        "language": "Lingua",
        "last_name": "Cognome",
        "phone_landline": "Numero fisso",
        "phone_mobile": "Numero di cellulare",
        "profession": "Qualifica professionale",
        "session_ended_at": "Ultima attività",
        "status": "Stato",
        "title": "Titolo"
      },
      "labels": {
        "addExistingCompany": "Aggiungi a un'organizzazione esistente",
        "contactDetails": "Dati di contatto",
        "createNewCompany": "Crea nuova organizzazione",
        "information": "Informazioni del profilo",
        "newTeamMember": "Nuovo partner",
        "notEditable": "Alcuni campi non sono più modificabili una volta che il partner è attivo",
        "partnerAddedState": "<b>Non ancora invitato</b>. Un'email di invito verrà inviata quando {partner_name} otterrà l'accesso a una decisione, segnalazione o documento pubblicati.",
        "selectedCompany": "Organizzazione selezionata",
        "start_by_selecting_project": "Inizi selezionando un progetto sulla sinistra."
      },
      "toasts": {
        "create": "Partner creato",
        "update": "Partner aggiornato"
      },
      "validation": {
        "mustBeEmailAddress": "È richiesto un indirizzo email valido",
        "needFirstName": "Nome obbligatorio",
        "needLastName": "Cognome obbligatorio",
        "requireEmailAddress": "Email obbligatoria"
      }
    }
  }
}
